var _excluded = ["className", "dropdown", "hideStatusIcon", "noShadow", "status", "tag", "type", "passwordToggleMessage", "allowShowPassword", "isOpen"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { visibilityIcon, visibilityOffIcon, checkMarkIcon, closeIcon, caratIcon } from '@lululemon/ecom-pattern-library-icons';
import Icon from '../../icons/index';
require("./field-input.css");
var styles = {
  "tagWrapper": "tagWrapper-2SDIg",
  "input": "input-2-hFT",
  "iconContainer": "iconContainer-3l9gt",
  "inputDisabled": "inputDisabled-291AW",
  "inputNoShadow": "inputNoShadow-zXkOv",
  "inputSuccess": "inputSuccess-1GTGz",
  "inputDropdown": "inputDropdown-2CczL",
  "iconHidden": "iconHidden-1_X7L",
  "iconSuccess": "iconSuccess-2xKiZ",
  "iconError": "iconError-VnY5J",
  "showHidePasswordWrapper": "showHidePasswordWrapper-A_5sS",
  "showHidePasswordAndErrorWrapper": "showHidePasswordAndErrorWrapper--dlOB",
  "inputWarning": "inputWarning-2XaKc",
  "inputError": "inputError-GQPIE",
  "inputDropdownWithStatus": "inputDropdownWithStatus-1HIAd",
  "inputHideStatusIcon": "inputHideStatusIcon-2GUBT",
  "iconCarat": "iconCarat-25RjA",
  "rotate": "rotate-Vimq1",
  "focus": "focus-2S3-X"
};
var SINGLE_ICON = 'single-icon';
var DOUBLE_ICON = 'double-icon';
var FieldInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      className,
      dropdown,
      hideStatusIcon,
      noShadow,
      status,
      tag,
      type,
      passwordToggleMessage,
      allowShowPassword,
      isOpen
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag || 'input';
  var [showPassword, setShowPassword] = useState(false);
  var elementType = type;
  if (type === 'password' && showPassword) {
    elementType = 'text';
  }
  var toggleMask = () => {
    setShowPassword(!showPassword);
  };
  var button = /*#__PURE__*/React.createElement("button", {
    onClick: toggleMask,
    type: "button",
    "aria-label": passwordToggleMessage,
    "aria-pressed": showPassword,
    className: styles.focus
  }, showPassword ? /*#__PURE__*/React.createElement(Icon, {
    content: visibilityOffIcon,
    "aria-hidden": "true"
  }) : /*#__PURE__*/React.createElement(Icon, {
    content: visibilityIcon,
    "aria-hidden": "true"
  }));
  var passwordField = display => {
    return /*#__PURE__*/React.createElement("div", {
      className: cs(styles.iconContainer, {
        [styles.showHidePasswordWrapper]: display === SINGLE_ICON,
        [styles.showHidePasswordAndErrorWrapper]: display === DOUBLE_ICON,
        [styles.inputHideStatusIcon]: hideStatusIcon,
        [styles.inputDisabled]: otherProps.disabled
      })
    }, display === SINGLE_ICON && button, display === DOUBLE_ICON && /*#__PURE__*/React.createElement(React.Fragment, null, button, /*#__PURE__*/React.createElement("div", {
      className: cs(styles.iconContainer, styles.iconError)
    }, /*#__PURE__*/React.createElement(Icon, {
      content: closeIcon,
      title: "Error"
    }))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.tagWrapper
  }, /*#__PURE__*/React.createElement(Tag, _extends({}, otherProps, {
    className: cs(styles.input, className, {
      [styles.inputDisabled]: otherProps.disabled,
      [styles.inputSuccess]: status === 'success',
      [styles.inputWarning]: status === 'warning',
      [styles.inputError]: status === 'error',
      [styles.inputNoShadow]: noShadow,
      [styles.inputDropdown]: dropdown,
      [styles.iconHidden]: hideStatusIcon
    }),
    "aria-invalid": status === 'error',
    ref: ref,
    type: elementType
  })), status === 'success' && /*#__PURE__*/React.createElement("div", {
    className: cs(styles.iconContainer, styles.iconSuccess, {
      [styles.inputHideStatusIcon]: hideStatusIcon,
      [styles.inputDisabled]: otherProps.disabled,
      [styles.inputDropdownWithStatus]: dropdown
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    content: checkMarkIcon,
    title: "Success"
  })), status === 'error' && type !== 'password' && /*#__PURE__*/React.createElement("div", {
    className: cs(styles.iconContainer, styles.iconError, {
      [styles.inputHideStatusIcon]: hideStatusIcon,
      [styles.inputDisabled]: otherProps.disabled,
      [styles.inputDropdownWithStatus]: dropdown
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    content: closeIcon,
    title: "Error"
  })), dropdown && !otherProps.disabled && /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    content: caratIcon,
    className: cs(styles.iconCarat, {
      [styles.rotate]: isOpen
    })
  }), type === 'password' && !status && allowShowPassword && passwordField(SINGLE_ICON), type === 'password' && status === 'error' && allowShowPassword && passwordField(DOUBLE_ICON));
});
FieldInput.propTypes = {
  className: PropTypes.string,
  dropdown: PropTypes.bool,
  hideStatusIcon: PropTypes.bool,
  noShadow: PropTypes.bool,
  status: PropTypes.oneOf(['success', 'warning', 'error']),
  /**
   * Custom HTML element or React component to render for
   * advanced use cases
   */
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  type: PropTypes.string,
  passwordToggleMessage: PropTypes.string,
  allowShowPassword: PropTypes.bool,
  isOpen: PropTypes.bool
};
FieldInput.defaultProps = {
  allowShowPassword: false,
  className: undefined,
  dropdown: false,
  hideStatusIcon: false,
  isOpen: false,
  noShadow: false,
  passwordToggleMessage: undefined,
  status: undefined,
  tag: 'input',
  type: 'text'
};
export default FieldInput;